import { formatClockHours } from "./utils/wall-clock-time.js";
import { MINUTES_PER_DAY, minutesToPercent } from "./timeline-range.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/RRule/TimelineHandle.tsx
function valueText(min) {
	return formatClockHours([Math.floor(min / 60)], min % 60);
}
function TimelineHandle({ label, min, onKeyDown, onPointerDown }) {
	return /* @__PURE__ */ jsx("div", {
		"aria-label": label,
		"aria-orientation": "horizontal",
		"aria-valuemax": MINUTES_PER_DAY - 1,
		"aria-valuemin": 0,
		"aria-valuenow": min,
		"aria-valuetext": valueText(min),
		className: "touch-none w-sm top-0 absolute h-full -translate-x-1/2 cursor-ew-resize",
		onKeyDown,
		onPointerDown,
		role: "slider",
		style: { left: `${minutesToPercent(min)}%` },
		tabIndex: 0,
		children: /* @__PURE__ */ jsx("span", { className: "bg-main mx-auto block h-full w-xxs rounded-full" })
	});
}
//#endregion
export { TimelineHandle };

//# sourceMappingURL=TimelineHandle.js.map